import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  actionTo?: string;
  onReset?: () => void;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  desc,
  actionLabel,
  actionTo,
  onReset,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-14 md:py-20 px-6 bg-background-100 rounded-lg border border-background-200">
      <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-background-200 flex items-center justify-center text-foreground-500">
        <i className={`${icon} text-2xl md:text-3xl`} />
      </div>
      <h3 className="mt-4 font-heading font-semibold text-foreground-950 text-base md:text-lg">{title}</h3>
      {desc && <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed max-w-md">{desc}</p>}
      <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
        {onReset && (
          <button
            type="button"
            onClick={onReset}
            className="h-10 px-5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200"
          >
            重置筛选条件
          </button>
        )}
        {actionTo && actionLabel && (
          <Link
            to={actionTo}
            className="h-10 px-5 inline-flex items-center rounded-md border border-background-300 text-foreground-800 hover:border-primary-400 hover:text-primary-600 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200"
          >
            {actionLabel}
          </Link>
        )}
      </div>
    </div>
  );
}